'use client';

import { ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface CarouselTab<T = unknown> {
  id: string;
  label: ReactNode;
  items: T[];
}

interface CarouselTabsProps<T> {
  tabs: CarouselTab<T>[];
  selectedTabId: string;
  onSelectTab: (tabId: string) => void;
}

export function CarouselTabs<T>({
  tabs,
  selectedTabId,
  onSelectTab,
}: CarouselTabsProps<T>): ReactNode {
  return (
    <div className="mb-2 flex flex-wrap justify-start gap-1">
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => onSelectTab(tab.id)}
          className={cn(
            'group inline-flex cursor-pointer items-center gap-1.5 rounded-full px-2.5 py-1 text-sm transition-[background-color,color] duration-300 ease-in-out',
            selectedTabId === tab.id
              ? 'bg-brand-accent text-brand-accent-foreground shadow-sm'
              : 'bg-muted text-primary hover:bg-primary hover:text-primary-foreground',
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
